import { FC } from 'react';

import { IncentiveCard } from '../loyalty-incentives-components/incentive-card/incentive-card';

import { RewardCategoryFlatList } from './loyalty-rewards.styled';
import { EnrichedReward, ILoyaltyRewardsCategoryList } from './types';

export const LoyaltyRewardsCategoryList: FC<ILoyaltyRewardsCategoryList> = ({
  rewards,
  locked,
  handleOnPress,
}) => {
  return (
    <RewardCategoryFlatList
      data={rewards}
      keyExtractor={item => (item as EnrichedReward).rewardId}
      overScrollMode={'never'}
      renderItem={({ item }) => {
        const { rewardId, incentive, inlineAlertMessage } = item as EnrichedReward;
        return incentive && rewardId ? (
          <IncentiveCard
            key={rewardId}
            incentive={incentive}
            handlePress={handleOnPress}
            locked={locked || false}
            inlineAlertMessage={inlineAlertMessage}
            isPictureBlurhashEnabled={false}
          />
        ) : null;
      }}
    />
  );
};
